module.exports = __webpack_public_path__ + "img/19_72.37a21ef1.png";